export default {
  ja:[
    "NerzExにようこそ！まずはプロフィール情報を埋めてみよう！",
    "アイデアを受け取りました！チェックしてみよう！",
    "住所を登録してね！",
    "前払いをしてね！",
    "配送されたみたいだよ！届いたらリクエストページから受取通知をしてあげてね！",
    "評価をしてあげてね！",
    "アイデアが採用されたよ！購入されるのを待ってね！",
    "前払いが完了しました！配送されるのを待ってね！",
    "向こうにグッズが到着したみたいなので、評価してあげてね！",
    "購入されたので、グッズを送ってあげてね！",
    "向こうにグッズが到着したみたいなので、評価してあげてね！",
    "購入成功だよ！ 前払いを完了させてね！",
    "取引が完了しました！ご利用ありがとうございました！",
    "残念、他の人のアイデアが採用されちゃったみたい。",
    "メッセージを受け取ったよ！確認しよう！",
    "売り出したアイテムが決済されたよ！確認してね！",
    "購入した商品が発送されたよ！届いたら報告をしてあげてね！",
    "評価をしてあげてね！",
    "評価をしてあげてね！",
  ],
  en: [
    "Welcome! As a start, let's fill up your profile!",
    "You've recieved an idea for your request!!",
    "What's your address?",
    'Please make a prepayment!',
    'The item has been sent! Send an arrival notice after the item arrives!',
    'Please rate!',
    'Your idea has been adopted!',
    "Prepayment is completed! Now it's time to ship the item!",
    "It seems the item has arrived! Please rate!",
    "The item has been purchased! Now it's time to ship the item!",
    'It seems the item has arrived! Please rate!',
    "You've successfully purchased! Now please complete the prepayment!",
    'Transaction Completed!! Thank you for using NerzExpress!!',
    'Uh oh, it seems that unfortunately the idea was not approved…',
    "You've recieved a message!",
    "Your item has been settled! Go check it out!!",
    "Your purchased item has been shipped! Make sure to notify the sender as soon as you receive it!!",
    'Please rate!',
    'Please rate!'
  ]
}
